import { render, staticRenderFns } from "./uploadImg.vue?vue&type=template&id=6e0dce26&scoped=true&"
import script from "./uploadImg.vue?vue&type=script&lang=js&"
export * from "./uploadImg.vue?vue&type=script&lang=js&"
import style0 from "./uploadImg.vue?vue&type=style&index=0&id=6e0dce26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0dce26",
  null
  
)

export default component.exports